// extracted by mini-css-extract-plugin
module.exports = {"container":"TransparentJPEG__container___2iCv8","image":"TransparentJPEG__image___1V8CQ","shadow":"TransparentJPEG__shadow___2DaEU"};